import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import "./HowItWorks.css";

const HowItWorks = () => {
  const [heading, setHeading] = useState({
    title: "",
    subtitle: "",
  });

  const [steps, setSteps] = useState([]);
  const [bannerImage, setBannerImage] = useState("/assets/images/live.png");

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      setHeading({
        title:
          data?.how_it_works_title?.value || data?.how_it_works_title || "",
        subtitle:
          data?.how_it_works_subtitle?.value ||
          data?.how_it_works_subtitle ||
          "",
      });

      const icons = [
        "bi-plug-fill",
        "bi-chat-dots-fill",
        "bi-diagram-3-fill",
        "bi-bar-chart-fill",
      ];

      const workflowSteps = [];

      for (let i = 1; i <= 4; i++) {
        const title =
          data?.[`workflow_step_${i}_title`]?.value ||
          data?.[`workflow_step_${i}_title`];

        const desc =
          data?.[`workflow_step_${i}_desc`]?.value ||
          data?.[`workflow_step_${i}_desc`];

        if (title && desc) {
          workflowSteps.push({
            title,
            desc,
            icon: icons[i - 1],
          });
        }
        if (data?.company_banner_image) {
          if (typeof data.company_banner_image === "string") {
            setBannerImage(data.company_banner_image);
          } else if (
            data.company_banner_image?.is_active === 1 &&
            data.company_banner_image?.value
          ) {
            setBannerImage(data.company_banner_image.value);
          }
        }
      }

      setSteps(workflowSteps);
    };

    fetchSettings();
  }, []);

  return (
    <section className="py-5 bg-white" id="how">
      <div className="container mt-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">{heading.title}</h2>
          {heading.subtitle && (
            <p className="text-muted mx-auto" style={{ maxWidth: "720px" }}>
              {heading.subtitle}
            </p>
          )}
        </div>

        <div className="row align-items-center g-5">
          <div className="col-lg-6 text-center">
            <img
              src={bannerImage}
              alt="Teleforce Messaging Workflow"
              className="img-fluid how-image"
            />
          </div>

          <div className="col-lg-6">
            {steps.map((step, index) => (
              <div key={index} className="d-flex align-items-start gap-3 mb-4">
                <div className="how-icon">
                  <i className={`bi ${step.icon}`}></i>
                </div>
                <div>
                  <h5 className="fw-semibold mb-1">{step.title}</h5>
                  <p className="text-muted mb-0">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
